import { ReactElement } from 'react';

import Box, { BoxProps } from '@mui/material/Box';
import Paper from '@mui/material/Paper';

export interface DecorativeTileProps {
  gridArea: string;
  image: string;
  index: number;
  sx?: BoxProps['sx'];
}

export default function DecorativeTile({
  gridArea,
  image,
  index,
  sx = {},
}: DecorativeTileProps): ReactElement {
  return (
    <Box
      className={`config decorative-tile-${index}`}
      sx={{
        gridArea,
        backgroundImage: `url(${image})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        ...sx,
      }}
      component={Paper}
    />
  );
}
